import React, { Component } from "react";
import { Table, CustomInput } from "reactstrap";
import { NotificatioErrController } from "../../../helpers/Utils";
import axios from "axios";
import { END_POINT } from "../../../constants/defaultValues";
import { ROLE_PERMISSION } from "../../../helpers/Roles";

export default class ListRole extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      data: [],
      groupedData: [],
      allPermissions: [],
    };
  }

  componentDidMount() {
    this.dataRender();
  }

  dataRender() {
    const tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT}/user-role/role`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        const roles = data.data || [];

        // Collect all unique permissions across all roles
        const permSet = new Set();
        roles.forEach((role) => {
          role.permissions.split("|").forEach((p) => permSet.add(p));
        });
        // Order: F first, then R, C, U, D, then others
        const permOrder = ["R", "C", "U", "D", "F", "RBD", "RC", "ACE"];
        const allPermissions = permOrder.filter((p) => permSet.has(p));

        // Group roles by 'group' field
        const groupMap = new Map();
        roles.forEach((role) => {
          const groupKey = role.group || "__general__";
          if (!groupMap.has(groupKey)) {
            groupMap.set(groupKey, []);
          }
          groupMap.get(groupKey).push(role);
        });

        // Build grouped array: general first, then named groups
        const groupedData = [];
        if (groupMap.has("__general__")) {
          groupedData.push({
            groupName: "Chung",
            roles: groupMap.get("__general__"),
          });
        }
        groupMap.forEach((roles, key) => {
          if (key !== "__general__") {
            const groupLabel =
              key === "analytics"
                ? "Thống kê"
                : key.charAt(0).toUpperCase() + key.slice(1);
            groupedData.push({ groupName: groupLabel, roles });
          }
        });

        this.setState({
          data: roles,
          groupedData,
          allPermissions,
          isLoading: true,
        });
      })
      .catch((err) => {
        NotificatioErrController(
          err?.response?.data?.responseText || "Có lỗi xảy ra",
        );
      });
  }

  onChangePermission = ({ alias, permission }) => {
    let permissions = null;

    if (permission === "F") {
      const find_role = this.state.data.find((role) => role.alias === alias);
      if (find_role) {
        permissions = find_role.permissions.split("|");
      }
    }

    this.props.onChangePermission({ alias, permission, permissions });
  };

  isDisabledPermission = ({ alias, permission }) => {
    if (permission === "C" || permission === "U" || permission === "D") {
      const find_role_R = this.props.settings.find(
        (setting) => setting.role_alias === alias && setting.permission === "R",
      );
      if (!find_role_R) return true;
    }
    return false;
  };

  hasPermission = (role, permission) => {
    return role.permissions.split("|").includes(permission);
  };

  render() {
    const { isLoading, groupedData, allPermissions } = this.state;
    const { disabled, roleType } = this.props;

    // Các alias đặc biệt của 3 role mặc định
    const DEFAULT_ROLE_ALIASES = [
      "cashier",
      "table_pending_payment",
      "kitchen",
    ];

    // Filter groupedData theo roleType
    const filteredGroupedData = groupedData
      .map((group) => ({
        ...group,
        roles: group.roles.filter((role) => {
          if (roleType) {
            // Role mặc định: chỉ hiển thị đúng alias đó
            return role.alias === roleType;
          } else {
            // Role thường: ẩn cả 3 alias mặc định
            return !DEFAULT_ROLE_ALIASES.includes(role.alias);
          }
        }),
      }))
      .filter((group) => group.roles.length > 0);

    if (!isLoading) return <div className="loading" />;

    return (
      <div className="table-responsive">
        <Table bordered hover size="sm" className="mb-0">
          <thead>
            <tr className="bg-light">
              <th style={{ minWidth: 200 }}>Tên quyền</th>
              {allPermissions.map((p) => (
                <th key={p} className="text-center" style={{ minWidth: 70 }}>
                  {ROLE_PERMISSION.get(p) || p}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredGroupedData.map((group) => (
              <React.Fragment key={group.groupName}>
                {filteredGroupedData.length > 1 && (
                  <tr>
                    <td
                      colSpan={allPermissions.length + 1}
                      className="font-weight-bold text-primary bg-light"
                      style={{ fontSize: "0.85rem" }}
                    >
                      {group.groupName}
                    </td>
                  </tr>
                )}
                {group.roles.map((role) => (
                  <tr key={role.alias}>
                    <td className="align-middle">{role.name}</td>
                    {allPermissions.map((perm) => {
                      const supported = this.hasPermission(role, perm);
                      if (!supported) {
                        return (
                          <td key={perm} className="text-center text-muted">
                            –
                          </td>
                        );
                      }

                      const isChecked = this.props.settings.find(
                        (s) =>
                          s.role_alias === role.alias && s.permission === perm,
                      );
                      const isDisabled =
                        disabled ||
                        this.isDisabledPermission({
                          alias: role.alias,
                          permission: perm,
                        });

                      return (
                        <td key={perm} className="text-center align-middle">
                          <CustomInput
                            type="checkbox"
                            id={`${role.alias}_${perm}`}
                            checked={!!isChecked}
                            disabled={isDisabled}
                            onChange={() =>
                              this.onChangePermission({
                                alias: role.alias,
                                permission: perm,
                              })
                            }
                            className="d-inline-block"
                            label=""
                          />
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}
